/* eslint-disable @typescript-eslint/naming-convention */
export class PopUp {
  constructor(
    public type?: string,
    public profileName?: string,
    public data?: string,
    public platform?: string,
    public article_type?: string
  ) {}
}
